<template>
  <div>
     <loading 
  :active.sync="LocationDetailLoading" 
        :is-full-page="true"
        color="green"
        ></loading>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white" class= "pt-3">
      <!-- <v-btn color="primary" dark class="mb-2" @click="newDialog=true,basicInformation=true;fetchAllPackageCategories()" round >Add Network</v-btn> -->
      <v-btn
        color="primary"
        dark
        class="mb-2"
        @click="addItem()"
        round
        v-if="typeof(this.$route.params.accessPointGroupId) == 'undefined'" 
      >Add Unit</v-btn>
      <!-- <v-btn color="primary" dark class="mb-2" @click="massUnitUpdate()" round>mass Unit Update</v-btn> -->
      <v-btn v-if="typeof(this.$route.params.contactId) == 'undefined' && typeof(this.$route.params.accessPointGroupId) == 'undefined'" color="primary" dark class="mb-2" @click="generateUnitCheck()" round>Generate Units</v-btn>
      <v-btn v-if="typeof(this.$route.params.contactId) == 'undefined'" @click="exportLocations()" round color="primary"><v-icon>get_app</v-icon>
      Export
      <!-- <download-excel
    :data="locationnetworkslocations"
    worksheet="export"
    :name="'Locations_'+new Date()+'.xls'">
    Export
</download-excel> -->
</v-btn>
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field> -->
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="$router.push({name: $route.name, query:{offset: $route.query.offset, records: $route.query.records, search: search}})"
      ></v-text-field>
    </v-toolbar>

     <!-- <v-dialog persistent v-if="accessPointGroupSearch" v-model="accessPointGroupSearch" max-width="1000px">
      <accesspointgroupsearchmodal
           @accessPointGroupSelected="onAccessPointGroupSelection"
             :multi="false"
             :preselected="selectedAccessPointGroups"
      ></accesspointgroupsearchmodal>
    </v-dialog> -->

    <!-- New  Unit Modal-->
    <v-dialog persistent v-model="newUnitDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Unit</h1>
      </v-toolbar>
      <!-- <v-toolbar flat color="white">
        <v-tabs  div="tabs">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab @click="addressInformation=true; installation=false; showDevices=false">Address Information</v-tab>
          </v-tabs>
      </v-toolbar> -->

      <v-card flat xs12 sm6 md4 v-show="addressInformation">
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="locationNetworks"
                item-text="name"
                item-value="id"
                label="*Select an associated Network"
                v-model="editedItem.locationNetworkId"
              >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="subComplexes.length>0">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="subComplexes"
                item-text="subComplexName"
                item-value="id"
                label="Select an associated Sub Complex"
                v-model="editedItem.locationNetworkSubComplexId"
              >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.locationDescription"
                  label="Location Description"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationTypes"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationTypeId"
                  label="*Location Type"
                  persistent-hint
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.erfNo" label="Erf No" 
                type="number"
                persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.unitNo" label="*Unit No" required persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.otherNo"
                  label="Other No"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.floorNo" label="Floor No"  type="number" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.subComplexName"
                  label="Sub Complex Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexStreetName"
                  label="Street Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexName"
                  label="Complex Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-switch v-model="editedItem.isActive" label="Active"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
        <v-layout justify-center>
          <v-btn color="primary" round @click="close">Cancel</v-btn>
        <v-btn v-if="editedItem.locationNetworkId&&editedItem.unitNo&&editedItem.locationTypeId" color="primary" round @click="saveNewUnit">Save</v-btn>
        <v-btn round disabled v-else>Save</v-btn>
        </v-layout>
      </v-card-actions>
      </v-card>

      
    </v-dialog>
    <!-- Edit Unit Modal -->
    <v-dialog persistent v-model="editUnitDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Edit Unit</h1>
      </v-toolbar>
      <v-card flat>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="locationNetworks"
                item-text="name"
                item-value="id"
                label="*Select an associated Network"
                v-model="editedItem.locationNetworkId"
              >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="subComplexes.length>0">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="subComplexes"
                item-text="subComplexName"
                item-value="id"
                label="Select an associated Sub Complex"
                v-model="editedItem.locationNetworkSubComplexId"
              >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.locationDescription"
                  label="Location Description"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationTypes"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationTypeId"
                  label="*Location Type"
                  persistent-hint
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.erfNo" label="Erf No"  type="number" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.unitNo" label="*Unit No" required persistent-hint></v-text-field>

              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.otherNo"
                  label="Other No"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.floorNo" label="Floor No"  type="number" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexStreetName"
                  label="Street Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexName"
                  label="Complex Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-switch v-model="editedItem.isActive" label="Active"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>

          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="save">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Generate Units -->
    <v-dialog persistent v-model="generateUnits" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Generate Units</h1>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="generateUnits=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="locationNetworks"
                item-text="name"
                item-value="id"
                label="*Select an associated Network"

                v-model="editedItem.locationNetworkId"
              >
               </v-autocomplete>
              <v-flex xs12 sm6 md4 v-if="subComplexes.length>0">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                :items="subComplexes"
                item-text="subComplexName"
                item-value="id"
                label="Select an associated Sub Complex"
                v-model="editedItem.locationNetworkSubComplexId"
              >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.prefix"
                  label="Unit Prefix"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.suffix"
                  label="Unit Suffix"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.unitStart"
                  label="*From Unit Number"
                  type="number"
                  step="1"
                  min="1"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.unitEnd"
                  label="*To Unit Number"
                  type="number"
                  step="1"
                  min="1"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationTypes"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationTypeId"
                  label="*Location Type"

                  persistent-hint
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.floorNo" label="Floor No"  type="number" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.complexStreetName"
                  label="Street Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.complexName" label="Complex Name" persistent-hint></v-text-field>
              </v-flex>
             

              <v-flex xs12 sm6 md4>
                <v-switch v-model="editedItem.isActive" label="Active"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn v-if="editedItem.locationNetworkId&&editedItem.locationTypeId&&editedItem.unitStart&&editedItem.unitEnd" color="primary" round @click="generateUnitLocations">Generate Units</v-btn>
            <v-btn round disabled v-else>Generate Units</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :items="locationnetworkslocations"
      item-key="name"
      align-center
      :rows-per-page-items="[25, 50, 100, 250]"
      disable-initial-sort
      style="cursor: pointer"
      hide-actions
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.locationDescription}}</td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.fibrePulled"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.equipmentInstalled"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.unitNo}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.erfNo}}</td>

        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.otherNo}}</td>
        <td v-if="props.item.locationNetworkSubComplexId!==null && props.item.locationNetworkSubComplex"
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.locationNetworkSubComplex.subComplexName}}</td>
        <td v-else
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        ></td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.complexStreetName}}</td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.complexName}}</td>
        <td @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.isActive===true"
        >
          <v-chip small :class="`Active white--text caption my-2`">Active</v-chip>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>
          <v-chip small :class="`Inactive white--text caption my-2`">Inactive</v-chip>
        </td>
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template> 

    </v-data-table>
     <div class="text-xs-center pt-2 white" :key="$route.query.offset">
      <v-pagination v-model="page" :length="Math.ceil(locationCount/$route.query.records)" :total-visible="7"></v-pagination>
    </div>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
// import LocationDetail from "@/components/Locations/LocationDetail.vue";
// import InstallationsAdd from "@/components/InstallationsAdd.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// import AccessPointGroupSearchModal from "@/components/AccessPointGroupSearchModal.vue";


export default {
  props: ["locationnetworkslocations","isloading", "locationCount"],
  components: {
    loading: Loading
    // accesspointgroupsearchmodal: AccessPointGroupSearchModal
  },
  data() {
    return {    
      selectedAccessPointGroups: [],
      accessPointGroupSearch: false,  
      LocationDetailLoading: false,
      newUnitDialog: false,
      subComplexes:[],
      locationBatchNumber: [],
      editUnitDialog: false,
      showScheduleForm: false,
      addressInformation: false,
      installation: false,
      showDevices: false,
      generateUnits: false,
      showDetails: true,
      loading: true,
      page: 1,
      snackbar: false,
      text: '',
      expand: false,
      search: "",
      dialog: false,
      newDialog: false,
      pagination: {},
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Description",
          align: "center",
          value: "locationDescription"
        },
        {
          text: "Passive Install Complete",
          align: "center",
          value: "fibrePulled"
        },
        {
          text: "Active Install Complete",
          align: "center",
          value: "equipmentInstalled"
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo"
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo"
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo"
        },
        // {
        //   text: "Sub Complex",
        //   align: "center",
        //   value: "locationNetworkSubComplex.subComplexName"
        // },
        {
          text: "Street Name",
          align: "center",
          value: "streetName"
        },
        {
          text: "Complex Name",
          align: "center",
          value: "complexName"
        },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        }
      ],
      accessPointGroups: [],
      locationNetworksLocations: [],
      locationNetworks: [],
      locationTypes: [],
      y: "top",
      editedIndex: -1,
      editedItem: {
        accessPointGroupId: null,
        locationNetworkSubComplexId: null,
        prefix: "",
        suffix: "",
        unitStart: "",
        unitEnd: "",
        locationDescription: "",
        locationTypeId: null,
        erfNo: null,
        otherNo: "",
        unitNo: "",
        floorNo: null,
        complexStreetName: "",
        complexName: "",
        subComplexName: "",
        fibrePulled: "",
        equipmentInstalled: "",
        locationNetworkId: null,
        isActive: true
      },
      defaultItem: {
        accessPointGroupId: null,
        name: "",
        isActive: true,
        isDeleted: ""
      }
    };
  },

  computed: {
    formattedDate() {
      return this.due ? format(this.due, "Do MMM YYYY") : "";
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    },
   
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    // search(value) {
    //   const route = {
    //     search: this.$route.search
    //   };
    //   if (this.search) {
    //     route.query = { search: this.search };
    //   }
    //   this.$router.push(route);
    // },
    // "$route.query.search": {
    //   immediate: true,
    //   handler(value) {
    //     this.search = value;
    //   }
    // },
    'editedItem.locationNetworkId': function (newVal, oldVal){
      if(newVal!==null){
        Api()
        .get('/locationNetworkSubcomplex/bynetwork/'+newVal)
        .then(response=>{
          this.subComplexes=response.data
        })
      }
    },
    page(value) {
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records
            }
          });
        }
      }
    }
  },

  created() {    
    this.initialize();
  },

  methods: {
    onAccessPointGroupSelection(e){
      this.selectedAccessPointGroups = e
      this.accessPointGroupSearch = false
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    async routerLinkToDetails(item) {    
      this.locationdetail = item;
      // this.editedIndex = this.locationnetworkslocations.indexOf(item);
      // let url =item
      // let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
      //   return el.url === '/locationNetworks/basic/:locationNetworkId/:locationId'})
      // await this.$store.dispatch('setCurrentRoute', route[0])
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        path:
          "/locationNetworks/basic/" +
          this.editedItem.locationNetworkId +
          "/" +
          this.editedItem.id
      });
    },
    getLocations(item) {
      Api()
        .get("/locationnetworks/" + this.$route.params.locationNetworkId)
        .then(response => {
          this.locationNetworksLocations = response.data[0].locations;
        });
    },
    getLocationNetworks() {
      Api()
        .get("/locationNetworks")
        .then(response => {
          this.locationNetworks = response.data;
        });
    },
    getlocationTypes() {
      Api()
        .get("/locationTypes")
        .then(response => {
          this.locationTypes = response.data;
        });
    },
     fetchAccessPointGroups() {
        this.isloading =true
      Api()
        .get("/accessPointGroups/getall")
        .then(response => {
          this.accessPointGroups = response.data;
          this.isloading =false
        });
      
    },
     fetchLocationsByContact(){
      Api()
      .get('/LocationContact/byContact/' + this.$route.params.contactId)
      .then(response=>{
        for(let i=0; i<response.data.length; i++){
        this.locationNetworksLocations.push(response.data[i].location)
        }
      })
    },
    initialize() {
      this.getLocationNetworks();
      this.getlocationTypes();
      // this.fetchAccessPointGroups();
      if(typeof(this.$route.params.contactId) != 'undefined'){
        this.$emit('locationnetworkslocations')
      }      
    },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.locationNetworksLocations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editUnitDialog = true;
       if(item.accessPointGroupId != null){
      this.selectedAccessPointGroups=[]
      this.selectedAccessPointGroups.push(item.accessPointGroup)
      }else{
       this.selectedAccessPointGroups=[{}]
      }
      }
    },

    deleteItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/locations/" + this.editedItem.id, {
        isActive: false,
        isDeleted: true
      }).then(response=>{        
      this.$emit('locationnetworkslocations')
      this.initialize()
      });this.initialize();
      }
    },
    addItem(){
      if(this.authCreate(this.$store.state.currentRoute)){
       this.newUnitDialog=true,this.addressInformation=true;this.clearFields()
      }
    },
    generateUnitCheck(){
      if(this.authCreate(this.$store.state.currentRoute)){
      this.clearFields(); this.generateUnits=true
      }
    },
    exportLocations(){
      Api()
        .get("/locations/export").then(response=>{
          var hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'locations.csv';
          hiddenElement.click();
        })
    },
    close() {
      this.dialog = false;
      this.newUnitDialog = false;
      this.editUnitDialog = false;
      this.generateUnits = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    clearFields() {
        this.selectedAccessPointGroups =[],
        this.editedItem.unitStart = "",
        this.editedItem.unitEnd = "",
        this.editedItem.locationDescription = "",
        this.editedItem.locationTypeId = null,
        this.editedItemerfNo = null,
        this.editedItem.otherNo = "",
        this.editedItem.unitNo = "",
        this.editedItem.floorNo = null,
        this.editedItem.complexStreetName = "",
        this.editedItem.complexName = "",
        this.editedItem.subComplexName = "",
        this.editedItem.fibrePulled = "",
        this.editedItem.equipmentInstalled = "",
        this.editedItem.locationNetworkId = null
    },
    save() {
        let tempContactId = this.$route.params.contactId
        let proceed = true;
         if (this.editedItem.locationNetworkId == "") {
        proceed = false;
        confirm("Please select a location network.");
      }
       if (this.editedItem.locationDescription == "") {
        this.editedItem.locationDescription =
        (this.editedItem.unitNo || "") +
            " " +
            (this.editedItem.complexStreetName || "") +
            " " +
            (this.editedItem.subComplexName || "") +
            " " +
            (this.editedItem.complexName || "")
      }
       if (this.editedItem.locationTypeId == "") {
        proceed = false;
        confirm("Please select a location type.");
      }
       if (this.editedItem.unitNo == "") {
        proceed = false;
        confirm("Please fill in an unit number.");
      }
       if (this.editedItem.complexName == "") {
        proceed = false;
        confirm("Please fill in a complex name.");
      }
     
      if (proceed == true) {
          if(typeof(this.$route.params.accessPointGroupId) == 'undefined'){
      Api().put("/locations/" + this.editedItem.id, {
        accessPointGroupId:this.selectedAccessPointGroups[0].id,
        locationDescription: this.editedItem.locationDescription,
        locationTypeId: this.editedItem.locationTypeId,
        erfNo: this.editedItem.erfNo,
        unitNo: this.editedItem.unitNo,
        otherNo: this.editedItem.otherNo,
        floorNo: this.editedItem.floorNo,
        complexStreetName: this.editedItem.complexStreetName,
        locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
        subComplexName: this.editedItem.subComplexName,
        complexName: this.editedItem.complexName,
        locationNetworkId: this.editedItem.locationNetworkId
      }).then(response=>{ 
         Api()
        .get("/locationNetworks/" + this.$route.params.locationNetworkId)
        .then(response => {
          if(response.data.length>0){

            this.locationNetworksLocations = response.data[0].locations;
          }
        })          
          this.$emit('locationnetworkslocations')
           if(typeof(tempContactId) != 'undefined'){
              this.$emit("locationnetworkslocations");
           }
           this.initialize();
        if(response.status===200){
            this.text = "Unit Successfully Updated!";
            this.$emit("locationSaved");
            this.snackbar = true;
          }           
      });;
      // this.initialize();    
      // this.$emit("locationSaved");
      this.close();     
      }
      else{
         Api().put("/locations/" + this.editedItem.id, {
        locationDescription: this.editedItem.locationDescription,
        locationTypeId: this.editedItem.locationTypeId,
        erfNo: this.editedItem.erfNo,
        unitNo: this.editedItem.unitNo,
        otherNo: this.editedItem.otherNo,
        floorNo: this.editedItem.floorNo,
        complexStreetName: this.editedItem.complexStreetName,
        locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
        subComplexName: this.editedItem.subComplexName,
        complexName: this.editedItem.complexName,
        locationNetworkId: this.editedItem.locationNetworkId
      }).then(response=>{   
             if(typeof(tempContactId) != 'undefined'){
              this.$emit("locationnetworkslocations");
              this.$emit("locationSaved");
           }
           this.initialize();
        if(response.status===200){
            this.text = "Unit Successfully Updated!";
            this.snackbar = true;
          }          
      });;
      this.close();     
      }
      }
    },
    saveNewUnit() {
      let tempContactId = this.$route.params.contactId
       let proceed = true;
         if (this.editedItem.locationNetworkId == null) {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (this.editedItem.locationDescription == "") {
        this.editedItem.locationDescription =
        (this.editedItem.unitNo || "") +
            " " +
            (this.editedItem.complexStreetName || "") +
            " " +
            (this.editedItem.subComplexName || "") +
            " " +
            (this.editedItem.complexName || "")
      }
       if (this.editedItem.locationTypeId == null) {
        proceed = false;
        confirm("Please select a location type.");
      }
       if (this.editedItem.unitNo == "") {
        proceed = false;
        confirm("Please fill in an unit number.");
      }
       if (this.editedItem.complexName == "") {
        proceed = false;
        confirm("Please fill in a complex name.");
      }
      if (proceed == true) {
        if(typeof(this.$route.params.accessPointGroupId) == 'undefined' && typeof(this.selectedAccessPointGroups[0]) != 'undefined'){
      Api().post("/locations", {
        accessPointGroupId:this.selectedAccessPointGroups[0].id,
        locationDescription: this.editedItem.locationDescription,
        locationTypeId: this.editedItem.locationTypeId,
        erfNo: this.editedItem.erfNo,
        unitNo: this.editedItem.unitNo,
        otherNo: this.editedItem.otherNo,
        locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
        floorNo: this.editedItem.floorNo,
        complexStreetName: this.editedItem.complexStreetName,
        subComplexName: this.editedItem.subComplexName,
        complexName: this.editedItem.complexName,

        locationNetworkId: this.editedItem.locationNetworkId
      }).then(response=>{
        this.text = "Unit Successfully Added!";
            this.snackbar = true;
      this.initialize();
      this.$emit("locationSaved");
      this.close(); 
      })   
      }
      else if(typeof(this.$route.params.accessPointGroupId) != 'undefined'){
         Api().post("/locations", {
        accessPointGroupId:this.$route.params.accessPointGroupId,
        locationDescription: this.editedItem.locationDescription,
        locationTypeId: this.editedItem.locationTypeId,
        erfNo: this.editedItem.erfNo,
        unitNo: this.editedItem.unitNo,
        otherNo: this.editedItem.otherNo,
        locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
        floorNo: this.editedItem.floorNo,
        complexStreetName: this.editedItem.complexStreetName,
        subComplexName: this.editedItem.subComplexName,
        complexName: this.editedItem.complexName,

        locationNetworkId: this.editedItem.locationNetworkId
      }).then(response=>{
        this.text = "Unit Successfully Added!";
            this.snackbar = true;
      this.initialize();
      this.$emit("locationSaved");
      this.close(); 
      })  
      }
      else{
   Api().post("/locations", {
        locationDescription: this.editedItem.locationDescription,
        locationTypeId: this.editedItem.locationTypeId,
        erfNo: this.editedItem.erfNo,
        unitNo: this.editedItem.unitNo,
        otherNo: this.editedItem.otherNo,
        locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
        floorNo: this.editedItem.floorNo,
        complexStreetName: this.editedItem.complexStreetName,
        subComplexName: this.editedItem.subComplexName,
        complexName: this.editedItem.complexName,

        locationNetworkId: this.editedItem.locationNetworkId
      }).then(response=>{
        this.text = "Unit Successfully Added!";
            this.snackbar = true;
      this.initialize();
      this.$emit("locationSaved");
      this.close(); 
      })
      

      }
      }
    },
    generateUnitLocations() {
       let proceed = true;
         if (this.editedItem.locationNetworkId == null) {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (this.editedItem.unitStart == "" || typeof(this.editedItem.unitStart) == 'undefined') {
        proceed = false;
        confirm("Please fill in a starting unit number.");
      }
       if (this.editedItem.unitEnd == "" || typeof(this.editedItem.unitEnd) == 'undefined') {
        proceed = false;
        confirm("Please fill in the ending unit number.");
      }
       if (this.editedItem.locationTypeId == null) {
        proceed = false;
        confirm("Please select a location type.");
      }
       if (this.editedItem.complexName == "" || typeof(this.editedItem.complexName) == 'undefined') {
        proceed = false;
        confirm("Please fill in a complex name.");
      }
     
      if (proceed == true) {
      this.locationBatchNumber = Math.floor(Math.random() * 1000000000000) + 1;
      if (this.editedItem.equipmentInstalled != true) {
        this.editedItem.equipmentInstalled = false;
      }
      if (this.editedItem.fibrePulled != true) {
        this.editedItem.fibrePulled = false;
      }
      if (this.editedItem.otherNo != true) {
        this.editedItem.otherNo = null;
      }
      let description = " "+(this.editedItem.complexStreetName||" ") +
      " " +
            (this.editedItem.floorNo||" ") +
            " " +
            (this.editedItem.subComplexName||" ") +
            " " +
            (this.editedItem.complexName||" ");
      description=description.replace(/  +/g, ' ')
      
      for (
        var i = this.editedItem.unitStart;
        i <= this.editedItem.unitEnd;
        i++
      ) {
        Api().post("/locations", {
          locationDescription:
            i.toString()+description
            ,
          locationTypeId: this.editedItem.locationTypeId,
          erfNo: this.editedItem.erfNo || "0",
          unitNo:
            (this.editedItem.prefix || "") +
            (i.toString() || " ") +
            (this.editedItem.suffix || ""),
          otherNo: this.editedItem.otherNo || "0",
          floorNo: this.editedItem.floorNo || "0",
          locationNetworkSubComplexId: this.editedItem.locationNetworkSubComplexId,
          complexStreetName: this.editedItem.complexStreetName || " ",
          subComplexName: this.editedItem.subComplexName || " ",
          complexName: this.editedItem.complexName || "",
          locationNetworkId: this.editedItem.locationNetworkId,
          locationBatchNumber: this.locationBatchNumber.toString()
        }).then(response=>{
          if(response.status===200){
            this.text = `Successfully Generated Unit(s)!`;
            this.snackbar = true;
          }
           this.$emit("locationSaved");
           this.initialize();
        });
      }
      this.close();
      this.$emit("locationSaved");
    }
    },
    async massUnitUpdate() {
      
      this.locationBatchNumber = Math.floor(Math.random() * 1000000000000) + 1;
      if (this.editedItem.equipmentInstalled != true) {
        this.editedItem.equipmentInstalled = false;
      }
      if (this.editedItem.fibrePulled != true) {
        this.editedItem.fibrePulled = false;
      }
      if (this.editedItem.otherNo != true) {
        this.editedItem.otherNo = null;
      }
      for (
        var i = 0;
        i <= this.locationnetworkslocations.length;
        i++
      ) {
        if(this.locationnetworkslocations[i].floorNo !==null && this.locationnetworkslocations[i].floorNo >0){
          this.editedItem.locationDescription = this.locationnetworkslocations[i].unitNo+" "+(this.locationnetworkslocations[i].complexStreetName||" ") +
      " floor " +
            (this.locationnetworkslocations[i].floorNo||" ") +
            " " +
            (this.locationnetworkslocations[i].subComplexName||" ") +
            " " +
            (this.locationnetworkslocations[i].complexName||" ");
      

        //   this.editedItem.locationDescription=
        // this.locationnetworkslocations[i].unitNo +
        //     " floor " + this.locationnetworkslocations[i].floorNo + " " +
        //     (this.locationnetworkslocations[i].complexStreetName || "") +
        //     " " +
        //     (this.locationnetworkslocations[i].subComplexName || "") +
        //     " " +
        //     (this.locationnetworkslocations[i].complexName || "")
        } else {
          this.editedItem.locationDescription=
        this.locationnetworkslocations[i].unitNo + " "+ 
            (this.locationnetworkslocations[i].complexStreetName || "") +
            " " +
            (this.locationnetworkslocations[i].subComplexName || "") +
            " " +
            (this.locationnetworkslocations[i].complexName || "")
        }
        this.editedItem.locationDescription=this.editedItem.locationDescription.replace(/  +/g, ' ')
        
        
        await Api().put("/locations/"+this.locationnetworkslocations[i].id, {
          locationDescription: this.editedItem.locationDescription,
        // locationTypeId: this.locationnetworkslocations[i].locationTypeId,
        // erfNo: this.locationnetworkslocations[i].erfNo,
        // unitNo: this.locationnetworkslocations[i].unitNo,
        // otherNo: this.locationnetworkslocations[i].otherNo,
        // floorNo: this.locationnetworkslocations[i].floorNo,
        // complexStreetName: this.locationnetworkslocations[i].complexStreetName,
        // subComplexName: this.locationnetworkslocations[i].subComplexName,
        // complexName: this.locationnetworkslocations[i].complexName,
        // locationNetworkId: this.locationnetworkslocations[i].locationNetworkId
        }).then(response=>{
          if(response.status===200){
            this.text = `Successfully Generated Unit(s)!`;
            this.snackbar = true;
          }
           this.$emit("locationSaved");
        });
      }
      this.close();
      this.$emit("locationSaved");
    }
  }
};
</script>
